import React from 'react';

const SECTION_BG_COLOR = "#2563EB"; // blue-600
const SUBTITLE_TEXT_COLOR = "#DBEAFE"; // blue-100 (Tailwind's blue-200 was #BFDBFE, blue-100 for more contrast)
const BUTTON_ONE_TEXT_COLOR = "#2563EB"; // blue-600
const BUTTON_TWO_TEXT_COLOR = "#2563EB"; // blue-600
const BUTTON_TWO_BG_HOVER_COLOR = "#1D4ED8"; // blue-700

interface CTASectionProps {
  onOpenContactModal: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onOpenContactModal }) => {
  return (
    <div style={{ backgroundColor: SECTION_BG_COLOR }} className="py-12"> {/* Linked to #contact */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          <span className="block">Ready to automate your business processes?</span>
          <span className="block" style={{ color: SUBTITLE_TEXT_COLOR }}>
            Transform your operations with AI automation and cloud infrastructure.
          </span>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <button
              onClick={onOpenContactModal}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md bg-white hover:bg-blue-50 transition-colors duration-150"
              style={{ color: BUTTON_ONE_TEXT_COLOR }}
            >
              Contact Us
            </button>
          </div>
          <div className="ml-3 inline-flex rounded-md shadow">
            <a
              href="https://calendly.com/kultio" // Link to consultation booking
              target="_blank" rel="noopener noreferrer" // Open in new tab
              style={{ backgroundColor: "white", color: BUTTON_TWO_TEXT_COLOR }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = BUTTON_TWO_BG_HOVER_COLOR;
                e.currentTarget.style.color = "white";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "white";
                e.currentTarget.style.color = BUTTON_TWO_TEXT_COLOR;
              }}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md transition-colors duration-150"
            >
              Book a Consultation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;